<template>
    <form action="/" v-if="currentStage === 'tagsAndRibbons'"
        class="byos-tags-and-ribbons-main-container pt-5 pt-md-6 filter-stage-content">
        <input class="has-single-tag-and-ribbon" type="hidden" :value="hasSingleLoveTagAndRibbon" />
        <div class="tags-and-ribbons-container byos-content-width px-3">
            <div class="row mb-5">
                <div class="col-12 col-md-6">
                    <div class="form-group col-12 col-sm mb-0 required p-0 recipient-name-field">
                        <input type="text" :class="`form-control gift-for-field ${validFields.name === false ? 'is-invalid' : ''}`" id="giftForInReview" name="giftForInReview"
                            :placeholder="$t('giftwrapping.review.giftfor')" required maxlength='20' v-model="name" @blur="validateField('name')" aria-describedby="recipient-name-error">
                        <label class="form-control-placeholder" for="giftForInReview"
                            v-html="$t('giftwrapping.review.giftfor')"></label>
                        <small class="invalid-feedback" role="alert" id="recipient-name-error">
                            <span v-html="validFields.name === false ? $t('message.oncard.error') : ''"></span>
                        </small>
                    </div>
                    <div class="tag-and-msg-feild-container mt-5">
                        <div class="message-container selection-main-container">
                            <div class="byos-gift-msg-container form-group mb-0 mx-auto text-left section-to-disable">
                                <label class="byos-message-label h3" for="byosGiftMessage"
                                    v-html="$t('byosgiftmessage.label')"></label>
                                <textarea :class="`form-control byos-gift-message ${noMessage ? 'disable-selection' : ''} ${validFields.message === false ? 'is-invalid' : ''}`" id="byosGiftMessage"
                                    aria-describedby="msg-char-limit msg-on-card-error"
                                    :maxlength="messageCharLimit"
                                    :placeholder="$t('byosgiftmessage.placeholder', [messageCharLimit])"
                                    :title="$t('byosgiftmessage.title')" :data-char-count="messageCharLimit"
                                    :data-missing-error="$t('message.oncard.error')" required v-model="message"
                                    @blur="validateField('message')" @input="onMessageInput($event)"></textarea>
                                <small id="msg-char-limit" class="form-text byos-msg-chars-len mt-2">
                                    <span class="byos-msg-chars-remain">{{ messageCharLimit - message.length }} </span>
                                    &nbsp;
                                    <span v-html="$t('msg.byosgiftmessage.charlimit')"></span>
                                </small>
                                <small role="alert" class="invalid-feedback" id="msg-on-card-error">
                                    <span v-html="validFields.message === false ? $t('message.oncard.error') : ''"></span>
                                </small>
                            </div>
                            <div class="form-group custom-checkbox no-message-checkbox mt-3">
                                <input type="checkbox" class="custom-control-input no-selection-please no-msg-please"
                                    id="byosNoMsg" name="byosNoMsg" v-model="noMessage" @click="validFields.message = true">
                                <label class="form-check-label no-message-checkbox-label" for="byosNoMsg"
                                    v-html="$t('nomessage.label')">
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 ribbon-wrapper mt-4 mt-md-0" data-id="">
                    <div class="ribbons-values-container">
                        <div class="byos-ribbons-heading h3" v-html="$t('select.ribbon')"></div>
                        <fieldset id="ribbons">
                            <legend class="byos-ribbon-color col-12 row">
                                <span v-html="$t('selectcolor.heading')"></span>
                                &nbsp;
                                <span class="selected-color text-capitalize">
                                    <template v-if="tagsAndRibbons['color'].value">
                                        {{ tagsAndRibbons['color'].value }}
                                    </template>
                                </span>
                            </legend>
                            <input type="radio" name="ribbons" v-for="ribbon in pdict.ribbons" :data-ribbon-id="ribbon.id" :data-ribbon-value="ribbon.value"
                                :class="`ribbon-item ${pdict.ribbons.length === 1 || tagsAndRibbons['color'].value === ribbon.value ? 'selected-ribbon-item' : ''}`"
                                :style="`background-color: ${ribbon.hexValue}`" :aria-label="$t('selectcolor.heading') + ' ' + ribbon.value"
                                :checked="pdict.ribbons.length === 1 || tagsAndRibbons['color'].value === ribbon.value"
                                @click="setTagsAndRibbons({ fieldName: 'color', fieldValue: (({ id, value }) => ({ id, value }))(ribbon) })" 
                                @keydown="(e) => { 
                                    if ([13, 32].includes(e.which)) {
                                        e.preventDefault();
                                        setTagsAndRibbons({ fieldName: 'color', fieldValue: (({ id, value }) => ({ id, value }))(ribbon) });
                                    }
                                }" />
                        </fieldset>
                        <small class="invalid-feedback"></small>
                    </div>
                    <fieldset class="mt-4" id="tags">
                        <legend class="byos-lovetag-heading h3" v-html="$t('select.lovetag')"></legend>
                        <div class="tags-image-container">
                            <div v-for="loveTag in pdict.loveTags" class="love-tag-wrapper">
                                <div :class="`love-tag-img-box ${pdict.loveTags.length === 1 || tagsAndRibbons['tag'].value === loveTag.value ? 'selected-love-tag' : ''}`">
                                    <input type="radio" name="tags" 
                                        :data-tag-id="loveTag.id" :data-tag-value="loveTag.value" 
                                        :aria-label="$t('select.lovetag') + ' ' + loveTag.value" 
                                        :checked="pdict.loveTags.length === 1 || tagsAndRibbons['tag'].value === loveTag.value"
                                        @click="setTagsAndRibbons({ fieldName: 'tag', fieldValue: (({ id, value }) => ({ id, value }))(loveTag) })"
                                        @keydown="(e) => { 
                                        if ([13, 32].includes(e.which)) {
                                            e.preventDefault();
                                            setTagsAndRibbons({ fieldName: 'tag', fieldValue: (({ id, value }) => ({ id, value }))(loveTag) });
                                        }
                                    }"/>
                                    <img :src="loveTag.imgSrc" class="img-fluid love-tag-img" :alt="$t('lovetag.alt.text')" />
                                    <span class="tagname col-12 text-center" v-html="loveTag.value"></span>
                                </div>
                            </div>
                            <small class="invalid-feedback"></small>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
        <div class="box-btn-container">
            <div class="byos-content-width px-3">
                <button :aria-label="$t('byos.btn.back.products')" class="select-product" type="button" @click="onSetCurrentStage('category')">
                    <span class="icon-chevron">
                        <SvgHelper :icon="'chevron'" :svgtitle="'chevron'" :decorative="true"></SvgHelper>
                    </span>
                    <span v-html="$t('tagsandribbons.selectproduct')"></span>
                </button>
                <button :class="`review-box-btn ${isTagsAndRibbonsObjectValid ? 'active' : ''}`" @click="onTagsAndRibbonsStageFinish" type="button" :aria-disabled="!isTagsAndRibbonsObjectValid">
                    <span v-html="$t('tagsandribbons.reviewbox')"></span>
                    <span class="icon-chevron">
                        <SvgHelper :icon="'chevron'" :svgtitle="'chevron'" :decorative="true"></SvgHelper>
                    </span>
                </button>
            </div>
        </div>
    </form>
</template>

<script setup>
import { SvgHelper } from "@/components/helper/util"
import { computed, reactive } from "vue";
import { mapGetters, mapMutations, mapActions } from "@/store/helper/vuex";
const { pdict, currentStage, tagsAndRibbons } = mapGetters();
const { setTagsAndRibbons, setByosSessionStorage } = mapMutations();
const { onSetCurrentStage } = mapActions();

const { messageCharLimit, FRESH_giftMessageCharRestriction } = window.vue.customPreferences;
const hasSingleLoveTagAndRibbon = computed(() => { return pdict.value.ribbons.length === 1 && pdict.value.loveTags.length === 1 ? true : false });

let validFields = reactive({
    message: null,
    name: null
});

const name = computed({
    get() {
        return tagsAndRibbons.value.name
    },
    set(value) {
        setTagsAndRibbons({ fieldName: 'name', fieldValue: value });
    }
});

const message = computed({
    get() {
        return tagsAndRibbons.value.message
    },
    set(value) {
        setTagsAndRibbons({ fieldName: 'message', fieldValue: value });
    }
});

const noMessage = computed({
    get() {
        return tagsAndRibbons.value.noMessage
    },
    set(value) {
        setTagsAndRibbons({ fieldName: 'noMessage', fieldValue: value });
        if (value === true) {
            setTagsAndRibbons({ fieldName: 'message', fieldValue: '' });
        }
    }
});

const validateField = (fieldName) => {
    switch (fieldName) {
        case 'message':
            validFields.message = noMessage.value ? true : (message.value.length > 0 ? true : false);
            break;
        case 'name':
            validFields.name = name.value.length > 0 ? true : false;
            break;
    }
}

const isTagsAndRibbonsObjectValid = computed(() => {
    return tagsAndRibbons.value.name.length > 0 &&
        (noMessage.value || message.value.length > 0) &&
        tagsAndRibbons.value.color.value && tagsAndRibbons.value.tag.value
});

const onTagsAndRibbonsStageFinish = () => {
    if (isTagsAndRibbonsObjectValid.value) {
        setByosSessionStorage();
        onSetCurrentStage('review');
    }

    // For some reason, this button does not fire the component event, it seems like there's something in vue that prevents it
    window.dataLayer?.push({
        event: 'gift_builder_interaction',
        gift_builder_step: 'Step 3: Review'
    });
}

const onMessageInput = (event) => {
    if (FRESH_giftMessageCharRestriction) {
        message.value = message.value.replace(/([\u4e00-\u9fa5|\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3])/g, '');
    } else {
        message.value = message.value.replace(/([\u4e00-\u9fa5|\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3\u00a9\u00ae\u2000-\u3300\ud83c\ud000-\udfff\ud83d\ud000-\udfff\ud83e\ud000-\udfff])/g, '');
    }
};
</script>